import { render, staticRenderFns } from "./RecoveryPasswordModal.vue?vue&type=template&id=1caea38e&scoped=true"
import script from "./RecoveryPasswordModal.vue?vue&type=script&lang=js"
export * from "./RecoveryPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./RecoveryPasswordModal.vue?vue&type=style&index=0&id=1caea38e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caea38e",
  null
  
)

export default component.exports